<template>
  <teleport to="body">
    <div v-if="modelValue" class="modal fade show d-block" tabindex="-1" role="dialog" aria-labelledby="modalLabel"
      aria-hidden="true">
      <div class="modal-dialog"  :class="modalDialogClass"
           :style="customWidth ? { maxWidth: customWidth, width: '100%' } : {}" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modalLabel">{{ title }}</h5>
            <button type="button" class="modal-close-btn" aria-label="Close" @click="hideModal">
              <span aria-hidden="true" id="closeModal">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <slot></slot>
          </div>
          <div v-if="!hideFooter" class="modal-footer" :class="classFooter">
            <button type="button" class="btn btn-primary" @click="handleSave">{{ translatedButtonLabel }}</button>
            <button v-if="!hideCancel" type="button" class="btn btn-grey" @click="hideModal">Schließen</button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="modelValue" class="modal-backdrop fade show"></div>
  </teleport>
</template>

<script setup>
import { computed, defineEmits, defineProps } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  modelValue: {
    type: Boolean,
    required: true,
  },
  title: {
    type: String,
    default: 'Modal Title',
  },
  classFooter: {
    type: String,
    default: 'justify-content-between',
  },
  sizeModal: {
    type: String,
    default: 'modal-lg',
  },
  hideCancel: {
    type: Boolean,
    default: true,
  },
  onSave: {
    type: Function,
    default: () => {
    },
  },
  buttonLabel: {
    type: String,
    default: '',
  },
  hideFooter: {
    type: Boolean,
    default: false
  },
  customWidth: {
    type: String,
    default: '',
  },

});

const { t } = useI18n();
const translatedButtonLabel = computed(() => props.buttonLabel || t('general.button.save'));

const emit = defineEmits(['update:modelValue']);

const hideModal = () => {
  emit('update:modelValue', false);
};

const handleSave = () => {
  if (props.onSave) {
    props.onSave();
  }
};

const modalDialogClass = computed(() => {
  if (props.customWidth) return '';
  return props.sizeModal || 'modal-md';
});

</script>

<style scoped>
.modal {
  overflow: auto;

}

::-webkit-scrollbar {
  display: none;
}

.modal-close-btn {
  margin: -1rem -1rem -1rem auto;
  padding: 1rem;
  background: transparent;
  border: 0;
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1;
  opacity: .5;
}

.modal-close-btn:hover {
  opacity: .75;
}

#closeModal {
  color: white;
  background-color: red;
  padding: 4px 8px;
  border-radius: 4px;
}
</style>